import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import { useNativeAppStore } from '../../../../store/store';

interface ConfirmExitParams {
  callback: () => void;
  path: string;
}

type ConfirmExitFunction = (params: ConfirmExitParams) => void;

const useConfirmExit = (confirmExit: ConfirmExitFunction): void => {
  const { navigator } = useContext(NavigationContext) as {
    navigator: {
      push: (location: { pathname: string; search?: string }) => void;
      replace: (location: { pathname: string; search?: string }) => void;
    };
  };

  const {
    isNativeApp,
    nativeAppConfig: { delegateRouting }
  } = useNativeAppStore();

  useEffect(() => {
    if (isNativeApp && delegateRouting) {
      const { push, replace } = navigator;

      navigator.push = (location: { pathname: string; search?: string }) => {
        const { pathname, search } = location || {};
        confirmExit({
          callback: () => push(location),
          path: pathname ? `${pathname}${search || ''}` : '/'
        });
      };

      navigator.replace = (location: { pathname: string; search?: string }) => {
        const { pathname, search } = location || {};
        confirmExit({
          callback: () => replace(location),
          path: pathname ? `${pathname}${search || ''}` : '/'
        });
      };

      return () => {
        navigator.push = push;
        navigator.replace = replace;
      };
    }

    return () => {};
  }, [navigator, confirmExit, isNativeApp, delegateRouting]);
};

export default useConfirmExit;
